import { notification } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { MainLayOutContect } from "../MainLayout";
import { io } from "socket.io-client";
import dayjs from "dayjs";

function MyNotification() {
  const { notificationSwitch, soundSwitch } = useContext(MainLayOutContect);
  const [api, contextHolder] = notification.useNotification();
  const [audioSrc, setAudioSrc] = useState(null);
  const audioRef = useRef(null);

  const handlePlaySound = () => {
    audioRef.current.play();
  };

  const audioPlay = (soundFile) => {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    setAudioSrc(`/sounds/${soundFile}`);
    audioRef.current.load();
  };

  useEffect(() => {
    const socket =
      process.env.NODE_ENV === "development"
        //? io(process.env.REACT_APP_IO)
        ? io()
        : io();
    function mapSoundFile(alarmId) {
      switch (alarmId) {
        case 0:
          return "1.mp3";
        case 1:
          return "2.mp3";
        case 2:
          return "3.mp3";
        case 3:
          return "4.mp3";
        case 4:
          return "5.mp3";
        case 5:
          return "20.mp3";
        case 6:
          return "9.mp3";
        case 7:
          return "10.mp3";
        case 8:
          return "11.mp3";
        case 9:
          return "6.mp3";
        case 10:
          return "7.mp3";
        case 11:
          return "8.mp3";
        case 12:
          return "12.mp3";
        case 13:
          return "13.mp3";
        case 14:
          return "21.mp3";
        case 15:
          return "22.mp3";
        case 16:
          return "23.mp3";
        case 17:
          return "30.mp3";
        case 18:
          return "31.mp3";
        case 19:
          return "32.mp3";
        case 20:
          return "33.mp3";
        case 21:
          return "34.mp3";
        case 22:
          return "35.mp3";
        case 23:
          return "36.mp3";
        case 24:
          return "29.mp3";
        default:
          return `${alarmId}.wav`;
      }
    }
    if (notificationSwitch) {
      const openNotificationWithIcon = (type, message, description) => {
        api[type]({
          message: `แจ้งเตือน ${message}`,
          description: description,
          duration: 10,
        });
      };

      socket.on("connect", () => {
        socket.emit("authen", localStorage.getItem("token"), (response) => {
          if (!response) {
            socket.close();
            localStorage.removeItem("token");
            window.location.href = "/authen";
          }
        });
      });

      socket.on("alarm", (data) => {
        if (soundSwitch) {
          audioPlay(mapSoundFile(data.AlarmID));
        }
        const str = `ทะเบียน ${data.VehicleName}, สถานที่ ${data.LocationName
          }, วันที่ ${dayjs(data.dateTime).format("D MMM YYYY")}, เวลา ${dayjs(
            data.dateTime
          ).format("HH:mm:ss")}, ความเร็ว ${data.speed} กม./ชม.`;
        openNotificationWithIcon("success", data.CategoryName, str);
      });
    } else {
      notification.destroy();
      socket.close();
      socket.disconnect();
    }
    return () => {
      socket.close();
      socket.disconnect();
    };
  }, [notificationSwitch, api, soundSwitch]);

  return (
    <>
      {contextHolder}
      <audio ref={audioRef} onLoadedData={handlePlaySound}>
        <source src={audioSrc} type="audio/mp3" />
      </audio>
    </>
  );
}

export default MyNotification;
